/**
 * Platform detection helpers.
 *
 * Used to hide any reference to other smartphone OS platforms when the
 * site is being viewed inside the iOS App Store build (per Apple
 * guideline 2.3.3). The website itself still shows everything to
 * Android/desktop/web visitors.
 *
 * `isAppleNativeContext()` returns true when the current load is most
 * likely the iOS WebToNative wrapper or an iOS Safari user that
 * installed the PWA — in either case we don't want to show Amazon
 * Appstore / Android download buttons.
 */

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // iPhone, iPad, iPod, plus iPadOS 13+ (which masquerades as Mac with touch)
  return /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isStandalonePWA() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches
    || window.navigator?.standalone === true
  );
}

/**
 * True when we should hide references to Amazon Appstore / Android /
 * Google Play. This covers:
 *   - Any iOS device (Safari + WKWebView), to be safe with App Store reviewers
 *   - Standalone PWA installs (likely already chose their store)
 */
export function shouldHideOtherPlatforms() {
  return isIOS();
}

export default { isIOS, isStandalonePWA, shouldHideOtherPlatforms };
